import { useState } from 'react';

type PhoneNumbersCustomInputProps = {
  onSearch: (searchTerm: string) => void;
};

export const PhoneNumbersCustomInput = ({
  onSearch,
}: PhoneNumbersCustomInputProps) => {
  const [value, setValue] = useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <li className="phone-number-field-holder">
      <div className="form-group nolabel">
        <div className="input-group">
          <input
            type="text"
            placeholder="Type a number to filter..."
            onChange={onChange}
            value={value}
            className="form-control"
          />
        </div>
      </div>
    </li>
  );
};
